import React, { useEffect, useState, useRef } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './AboutUsTerra.css'

const AboutUsTerra = () => {
     const homee = {
            1: "Revolutionizing Cleanliness with Cutting-Edge Nanotechnology!",
            2: "We are specialized in Nano copper & Nano Silver technology products.",
            3: "Find Out More",
            4: "About Nano",
            5: "What is Nano ?",
            6: "Nanotechnology is the ability to control or manipulate materials on the atomic scale to create structures that have novel properties and functions because of their size, shape or composition. These structures are typically nanometers in size. In proceeding from a mm to nm scale the specific surface area increases by 3 orders of magnitude, thereby changing its physical, chemical, mechanical, electrical, magnetic, biological properties.",
            7: "Innovative Nanotech Solutions",
            8: "Uncompromising Quality",
            9: "Eco-Friendly Craftsmanship",
            10: "Anti Microbial Properties",
            11: "Non –Toxic & Non - Hazardous",
            12: "Offering Affordable, High-Quality Products For Unparalleled Cleaning Power",
            13: "Why Choose us",
            14: "Our Product will Covers all areas of your home or office",
            15: "Designed to protect every corner—our product ensures your home and office stay safe, secure, and stress-free",
            16: 'Deep Cleaning ("Anti Microbial, Anti-fungal, Anti-Viral, Anti-bacterial")',
            17: 'Versatile ("Suitable for multiple surfaces")',
            18: 'Non-Toxic ("Safe for humans, pets, and the environment")',
            19: 'High Performance ("Advance Technology for high performance")',
            20: 'Eco-Friendly ("Biodegradable and reduces water usage")',
            21: 'Cost Efficiency ("These products can lower overall maintenance costs.")',
            22: "Our Product Popular In Place",
            23: "Kitchen Cleaning",
            24: "Hospital Cleaning",
            25: "General Cleaning",
            26: "About Us",
            27: "Our Best Services & Popular Products Here",
            28: "Terra Clenz is the company, Producing exceptional Cleaning products for a Wide range of Applications with Nanotechnology. We are specialized in Nano copper & Nano Silver technology products.",
            29: "Innovative Nanotech Solutions for Everyday Living",
            30: "We specialize in the wholesale and retail sale of innovative, nanotechnology-enhanced products that can be used in everyday life.",
            31: "Uncompromising Quality, Unbeatable Value – Guaranteed!",
            32: "Eco-Friendly Craftsmanship Meets Superior Cleaning Power",
            33: "We combine meticulous craftsmanship with stringent environmental standards, offering affordable, high-quality products for unparalleled cleaning power.",
            34: "Our Core Value",
            35: "Trust",
            36: "Excellence",
            37: "Reliability",
            38: "Reverence",
            39: "Ambition",
            40: "Vision",
            41: "To Become The Most Trusted, Respected, and Reliable Commercial Cleaning Product Brand. To be the Best in What We Do...",
            42: "Mission",
            43: "Productive, Safer, and Healthier Environment Through a Robust Range of Cleaning Products, Industry-Leading Standards, and Sustainable Business Practices.",
            44: "We Take Care Of Your Health",
            45: "The All In One Cleaning Products You've been Looking For",
            46: "Terraclenz Product Benefits",
            47: "Anti Microbial Properties",
            48: "Non–Toxic & Non-Hazardous",
            49: "Nano Technology implemented",
            50: "Bio Degradable",
            51: "Product Price & Quality",
            52: "Environment Friendly",
            53: "Our Product Offerings",
            54: "Hand Wash Mixed Fruit | Nano Silver",
            55: "BathRoom Cleaner | Cleaner",
            56: "Glass & Mirror Cleaner | NanoCopper",
            57: "Floor Cleaner & Disinfectant | NanoCopper",
            58: "BathRoom Wall & Tile Cleaner | Domestic & industrial use",
            59: "Toilet Bowl & Urinal Cleaner | Domestic & industrial Use",
            60: "Gadget Cleaner | NanoCopper",
            61: "Sodium Hypo Chlorite Solutions | NanoCopper",
            62:"We adhere to the strictest quality standards and guarantee the best offer on the market.",
            63:"assets/img/portfolio/english.png",
            64:"assets/img/portfolio/englishmobile.png"
          };
          const hometa = {
            1: "கட்டுமான சுத்தம் மற்றும் நானோ தொழில்நுட்பத்துடன் புரட்சிகரமாக மாற்றம் ஏற்படுத்துகிறது!",
            2: "நாங்கள் நானோ செம்பு மற்றும் நானோ வெள்ளி தொழில்நுட்ப தயாரிப்புகளில் நிபுணத்துவம் பெற்றவர்கள்.",
            3: "மேலும் கண்டுபிடிக்க ​",
            4: "நானோ பற்றி ​",
            5: "நானோ என்றால் என்ன? ​",
            6: "நானோ தொழில்நுட்பம் என்பது அணு அளவில் பொருட்களைக் கட்டுப்படுத்தும் அல்லது கையாளும் திறன், அவற்றின் அளவு, வடிவம் அல்லது கலவை காரணமாக புதிய பண்புகள் மற்றும் செயல்பாடுகளைக் கொண்ட கட்டமைப்புகளை உருவாக்குகிறது. இந்த கட்டமைப்புகள் பொதுவாக நானோமீட்டர் அளவில் இருக்கும். ஒரு மிமீ முதல் என்எம் அளவு வரை செல்லும்போது குறிப்பிட்ட பரப்பளவு அதன் இயற்பியல், வேதியியல், இயந்திரம், மின், காந்த, உயிரியல் பண்புகளை மாற்றுவதன் மூலம் 3 ஆர்டர்கள் அளவு அதிகரிக்கிறது. ​",
            7: "புதுமையான நானோ தொழில்நுட்ப தீர்வுகள் ​",
            8: "சமரசம் செய்யாத தரம் ​",
            9: "சுற்றுச்சூழல் நட்பு கைவினைத்திறன் ​",
            10: "நுண்ணுயிர் எதிர்ப்பு பண்புகள் ​",
            11: "நச்சு அல்லாத மற்றும் அபாயகரமானது அல்ல ​",
            12: "இணையற்ற துப்புரவு ஆற்றலுக்கான மலிவு விலையில், உயர்தர தயாரிப்புகளை வழங்குகிறது ​",
            13: "எங்களை ஏன் தேர்வு செய்ய வேண்டும் ​",
            14: "எங்கள் தயாரிப்பு உங்கள் வீடு அல்லது அலுவலகத்தின் அனைத்து பகுதிகளையும் உள்ளடக்கும் ​",
            15: "ஒவ்வொரு மூலையையும் பாதுகாக்கும் வகையில் வடிவமைக்கப்பட்டுள்ளது—எங்கள் தயாரிப்பு உங்கள் வீடு மற்றும் அலுவலகம் பாதுகாப்பாகவும் மன அழுத்தமின்றியும் இருப்பதை உறுதி செய்கிறது ​",
            16: '​ஆழமான சுத்தம் ("எதிர்ப்பு நுண்ணுயிர், பூஞ்சை எதிர்ப்பு, வைரஸ் எதிர்ப்பு, பாக்டீரியா எதிர்ப்பு")​',
            17: 'பல்துறை ("பல மேற்பரப்புகளுக்கு ஏற்றது") ​',
            18: 'நச்சுத்தன்மையற்றது ("மனிதர்கள், செல்லப்பிராணிகள் மற்றும் சுற்றுச்சூழலுக்கு பாதுகாப்பானது") ​',
            19: 'உயர் செயல்திறன் ("உயர் செயல்திறனுக்கான அட்வான்ஸ் டெக்னாலஜி") ​',
            20: 'சுற்றுச்சூழல் நட்பு ("மக்கும் மற்றும் நீர் பயன்பாட்டை குறைக்கிறது") ​',
            21: 'செலவு திறன் ("இந்த தயாரிப்புகள் ஒட்டுமொத்த பராமரிப்பு செலவுகளை குறைக்கலாம்.") ​',
            22: "எங்கள் தயாரிப்பு பிரபலமாக உள்ளது​",
            23: "சமையலறை துப்புரவு",
            24: "ஆசுபத்திரி துப்புரவு",
            25: "பொதுவான தயாரிப்புகள்",
            26: "எங்களை பற்றி​",
            27: "இங்கே எங்கள் சிறந்த சேவைகள் & பிரபலமான தயாரிப்புகள்​",
            28: "டெர்ரா க்ளென்ஸ் என்பது நானோ தொழில்நுட்பத்துடன் பரந்த அளவிலான பயன்பாடுகளுக்கு விதிவிலக்கான துப்புரவு தயாரிப்புகளை உற்பத்தி செய்யும் நிறுவனம். நாங்கள் நானோ செம்பு மற்றும் நானோ வெள்ளி தொழில்நுட்ப தயாரிப்புகளில் நிபுணத்துவம் பெற்றவர்கள்.",
            29: "அன்றாட வாழ்க்கைக்கான புதுமையான நானோடெக் தீர்வுகள்​",
            30: "நாங்கள் அன்றாட வாழ்வில் பயன்படுத்தக்கூடிய புதுமையான, நானோ தொழில்நுட்பத்தால் மேம்படுத்தப்பட்ட தயாரிப்புகளின் மொத்த மற்றும் சில்லறை விற்பனையில் நிபுணத்துவம் பெற்றவர்கள்.​",
            31: "சமரசமற்ற தரம், வெல்ல முடியாத மதிப்பு - உத்தரவாதம்!​",
            32: "சுற்றுச்சூழலுக்கு உகந்த கைவினைத்திறன் உயர்ந்த துப்புரவு சக்தியை சந்திக்கிறது​",
            33: "நாங்கள் நுணுக்கமான கைவினைத்திறனை கடுமையான சுற்றுச்சூழல் தரநிலைகளுடன் இணைத்து, இணையற்ற துப்புரவு சக்தியுடன் மலிவு விலையில், உயர்தர தயாரிப்புகளை வழங்குகிறோம்.​",
            34: "எங்கள் முக்கிய மதிப்பு​",
            35: "நம்பிக்கை​",
            36: "சிறப்பு​",
            37: "நம்பகத்தன்மை​",
            38: "மரியாதை​",
            39: "லட்சியம்​",
            40: "காணொளி",
            41: "மிகவும் நம்பகமானது, மதிப்புமிக்கது மற்றும் விசுவாசத்திற்குரிய வணிக துப்புரவு தயாரிப்பு பிராண்டாக உயர்வதே எங்கள் இலக்கு. நாம் செய்வதிலேயே சிறந்ததாக இருப்பது எங்கள் குறிக்கோள்...",
            42: "​பணிமுனை ",
            43: "உயர்ந்த தரத்திலான துப்புரவு பொருட்கள், தொழில்துறை முன்னணி தரநிலைகள் மற்றும் நிலைத்துறைக் கோட்பாடுகளின் மூலம் உற்பத்திவாய்ந்த, பாதுகாப்பான மற்றும் ஆரோக்கியமான சூழலை உருவாக்குதல்.",
            44: "உங்கள் ஆரோக்கியத்தை நாங்கள் கவனித்துக்கொள்கிறோம்​",
            45: "நீங்கள் தேடிக்கொண்டிருந்த ஆல் இன் ஒன் துப்புரவுப் பொருட்கள்​",
            46: "டெர்ராக்லென்ஸ் தயாரிப்பின் நன்மைகள்​",
            47: "நுண்ணுயிர் எதிர்ப்பு பண்புகள்",
            48: "நச்சு அல்லாத மற்றும் அபாயகரமானது அல்ல",
            49: "நானோ தொழில்நுட்பம் செயல்படுத்தப்பட்டது",
            50: "காற்று சுத்திகரிப்பு",
            51: "பொருட்களின் விலை மற்றும் தரம்",
            52: "சுற்றுச்சூழல் நட்பு",
            53: "எங்கள் தயாரிப்பு சலுகைகள்​",
            54: "கை கழுவும் மூலிகைகள் | நானோ வெள்ளி",
            55: "குளியலறை சுத்தம் செய்பவர் | சுத்தம் செய்யும் பொருள்",
            56: "கண்ணாடி மற்றும் கண்ணாடி குளிர்ந்துவைக்கும் பொருள் | நானோசெம்பு",
            57: "வசதி தலையை சுத்தம் செய்யும் மற்றும் தொற்று நிவர்த்தி பொருள் | நானோசெம்பு",
            58: "குளியலறை சுவர் மற்றும் குழாய் சுத்தம் செய்பவர் | வீட்டிலும் தொழிற்சாலையிலும் பயன்படும்",
            59: "கழிப்பறை பாத்திரம் மற்றும் மூத்திரம் கழிப்பான் சுத்தம் செய்பவர் | வீட்டிலும் தொழிற்சாலையிலும் பயன்படும்",
            60: "பொருட்கள் சுத்தம் செய்பவர் | நானோசெம்பு",
            61: "சோடியம் ஹைபோக்ளோரைட் தீர்வுகள் | நானோசெம்பு",
            62:"நாம் கடுமையான தரத் தரநிலைகளை பின்பற்றுகிறோம் மற்றும் சந்தையில் சிறந்த ஒப்பந்தத்தை உறுதி செய்கிறோம்.",
            63:"assets/img/portfolio/tamil.png",
            64:"assets/img/portfolio/tamilmobile.png"
          };
          const homeka = {
            1: "ಅತ್ಯಾಧುನಿಕ ನ್ಯಾನೊತಂತ್ರಜ್ಞಾನದೊಂದಿಗೆ ಸ್ವಚ್ಛತೆಯಲ್ಲಿ ಕ್ರಾಂತಿ!",
            2: "ನ್ಯಾನೋ ಕಾಪರ್ ಮತ್ತು ನ್ಯಾನೋ ಸಿಲ್ವರ್ ತಂತ್ರಜ್ಞಾನ ಉತ್ಪನ್ನಗಳಲ್ಲಿ ನಾವು ಪರಿಣತಿ ಹೊಂದಿದ್ದೇವೆ",
            3: "ಇನ್ನಷ್ಟು ತಿಳಿದುಕೊಳ್ಳಿ",
            4: "ನ್ಯಾನೋ ಬಗ್ಗೆ",
            5: "ನ್ಯಾನೋ ಎಂದರೇನು?",
            6: "ನ್ಯಾನೊಟೆಕ್ನಾಲಜಿ ಎಂದರೆ ಅಣುಗಳ ಮಟ್ಟದಲ್ಲಿ ವಸ್ತುಗಳನ್ನು ನಿಯಂತ್ರಿಸಲು ಅಥವಾ ಮಾರ್ಪಡಿಸಲು ಸಾಧ್ಯವಾಗುವ ಸಾಮರ್ಥ್ಯ. ಇದರಿಂದ ಅವುಗಳ ಗಾತ್ರ, ಆಕಾರ ಅಥವಾ ಸಂಯೋಜನೆಯಿಂದಾಗಿ ಹೊಸ ಗುಣಲಕ್ಷಣಗಳು ಮತ್ತು ಕಾರ್ಯಗಳನ್ನು ಹೊಂದಿರುವ ರಚನೆಗಳನ್ನು ಸೃಷ್ಟಿಸಬಹುದು. ಈ ರಚನೆಗಳು ಸಾಮಾನ್ಯವಾಗಿ ನ್ಯಾನೊಮೀಟರ್ಗಳಷ್ಟು ಗಾತ್ರವನ್ನು ಹೊಂದಿರುತ್ತವೆ. ಮಿಲಿಮೀಟರ್(mm) ಅಳತೆಯಿಂದ ನ್ಯಾನೊಮೀಟರ್(nm) ಅಳತೆಗೆ ಹೋದಾಗ, ನಿರ್ದಿಷ್ಟ ಮೇಲ್ಮೈ ಪ್ರದೇಶವು 3 ಕ್ರಮಗಳಿಂದ ಹೆಚ್ಚಾಗುತ್ತದೆ. ಇದು ಅದರ ಭೌತಿಕ, ರಾಸಾಯನಿಕ, ಯಾಂತ್ರಿಕ, ವಿದ್ಯುತ್, ಕಾಂತೀಯ, ಜೈವಿಕ ಗುಣಲಕ್ಷಣಗಳನ್ನು ಬದಲಾಯಿಸುತ್ತದೆ.",
            7: "ನವೀನ ನ್ಯಾನೋಟೆಕ್ ಪರಿಹಾರಗಳು",
            8: "ರಾಜಿಯಾಗದ ಗುಣಮಟ್ಟ",
            9: "ಪರಿಸರ ಸ್ನೇಹಿ ಕರಕುಶಲತೆ",
            10: "ಸೂಕ್ಷ್ಮಜೀವಿ ವಿರೋಧಿ ಗುಣಲಕ್ಷಣಗಳು",
            11: "ವಿಷರಹಿತ ಮತ್ತು ಅಪಾಯಕಾರಿಯಲ್ಲದ",
            12: "ಅಪ್ರತಿಮ ಶುಚಿಗೊಳಿಸುವ ಶಕ್ತಿಗಾಗಿ ಕೈಗೆಟುಕುವ, ಉತ್ತಮ-ಗುಣಮಟ್ಟದ ಉತ್ಪನ್ನಗಳನ್ನು ನೀಡಲಾಗುತ್ತಿದೆ",
            13: "ನಮ್ಮನ್ನು ಯಾಕೆ ಆಯ್ಕೆಮಾಡಬೇಕು",
            14: "ನಮ್ಮ ಉತ್ಪನ್ನವು ನಿಮ್ಮ ಮನೆ ಅಥವಾ ಕಚೇರಿಯ ಎಲ್ಲಾ ಪ್ರದೇಶಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ",
            15: "ಪ್ರತಿಯೊಂದು ಮೂಲೆಯನ್ನು ರಕ್ಷಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ - ನಮ್ಮ ಉತ್ಪನ್ನವು ನಿಮ್ಮ ಮನೆ ಮತ್ತು ಕಚೇರಿಯು ಸುರಕ್ಷಿತ, ಭದ್ರ ಮತ್ತು ಒತ್ತಡ-ಮುಕ್ತವಾಗಿ ಇರಿಸುತ್ತದೆ ಎಂದು ಖಚಿತಪಡಿಸುತ್ತದೆ.",
            16: 'ಆಳವಾದ ಶುದ್ಧೀಕರಣ ("ಸೂಕ್ಷ್ಮಜೀವಿ ವಿರೋಧಿ, ಶಿಲೀಂಧ್ರ ವಿರೋಧಿ, ವೈರಲ್ ವಿರೋಧಿ, ಬ್ಯಾಕ್ಟೀರಿಯಾ ವಿರೋಧಿ")',
            17: 'ಬಹುಮುಖ ("ಬಹು ಮೇಲ್ಮೈಗಳಿಗೆ ಸೂಕ್ತವಾಗಿದೆ")',
            18: 'ವಿಷರಹಿತ ("ಮಾನವರಿಗೆ, ಸಾಕುಪ್ರಾಣಿಗಳು ಮತ್ತು ಪರಿಸರಕ್ಕೆ ಸುರಕ್ಷಿತ")',
            19: 'ಹೆಚ್ಚಿನ ಕಾರ್ಯಕ್ಷಮತೆ ("ಉನ್ನತ ಕಾರ್ಯಕ್ಷಮತೆಗಾಗಿ ಆಧುನಿಕ ತಂತ್ರಜ್ಞಾನ")',
            20: 'ಪರಿಸರ ಸ್ನೇಹಿ ("ಜೈವಿಕ ವಿಘಟನೀಯ ಮತ್ತು ನೀರಿನ ಬಳಕೆಯನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ")',
            21: 'ವೆಚ್ಚ ದಕ್ಷತೆ ("ಈ ಉತ್ಪನ್ನಗಳು ಒಟ್ಟಾರೆ ನಿರ್ವಹಣಾ ವೆಚ್ಚವನ್ನು ಕಡಿಮೆ ಮಾಡಬಲ್ಲವು.")',
            22: "ನಮ್ಮ ಉತ್ಪನ್ನವು ಜನಪ್ರಿಯವಾಗಿದೆ",
            23: "ಅಡುಗೆಮನೆ ಶುದ್ಧೀಕರಣ",
            24: "ಆಸ್ಪತ್ರೆ ಶುದ್ಧೀಕರಣ",
            25: "ಸಾಮಾನ್ಯ ಉತ್ಪನ್ನಗಳು",
            26: "ನಮ್ಮ ಬಗ್ಗೆ",
            27: "ನಮ್ಮ ಅತ್ಯುತ್ತಮ ಸೇವೆಗಳು & ಜನಪ್ರಿಯ ಉತ್ಪನ್ನಗಳು ಇಲ್ಲಿ",
            28: "ಟೆರ್ರಾ ಕ್ಲೆಂಜ್ ಕಂಪನಿಯಾಗಿದ್ದು, ನ್ಯಾನೋಟೆಕ್ನಾಲಜಿಯೊಂದಿಗೆ ವ್ಯಾಪಕ ಅನುವರ್ತನೆಗಳಿಗೆ ಅತ್ಯುತ್ತಮ ಕ್ಲೀನಿಂಗ್ ಉತ್ಪನ್ನಗಳನ್ನು ಉತ್ಪಾದಿಸುತ್ತದೆ. ನ್ಯಾನೋ ಕಾಪರ್ ಮತ್ತು ನ್ಯಾನೋ ಸಿಲ್ವರ್ ಟೆಕ್ನಾಲಜಿ ಉತ್ಪನ್ನಗಳಲ್ಲಿ ನಾವು ಪರಿಣತಿ ಹೊಂದಿದ್ದೇವೆ",
            29: "ದೈನಂದಿನ ಜೀವನಕ್ಕಾಗಿ ನವೀನ ನ್ಯಾನೋಟೆಕ್ ಪರಿಹಾರಗಳು",
            30: "ನಮ್ಮಲ್ಲಿ ದೈನಂದಿನ ಜೀವನದಲ್ಲಿ ಬಳಸಬಹುದಾದ ನವೀನ, ನ್ಯಾನೋತಂತ್ರಜ್ಞಾನ-ವರ್ಧಿತ ಉತ್ಪನ್ನಗಳ ಸಗಟು ಮತ್ತು ಚಿಲ್ಲರೆ ಮಾರಾಟದಲ್ಲಿ ಪರಿಣತಿ ಹೊಂದಿದ್ದೇವೆ.",
            31: "ರಾಜಿಯಾಗದ ಗುಣಮಟ್ಟ, ಸೋಲಿಸಲಾಗದ ಮೌಲ್ಯ - ಖಚಿತವಾಗಿದೆ!",
            32: "ಪರಿಸರ ಸ್ನೇಹಿ ಕರಕುಶಲತೆಯು ಮತ್ತು ಉತ್ತಮ ಶುದ್ಧೀಕರಣ ಶಕ್ತಿ",
            33: "ನಾವು ನಿಖರವಾದ ಕರಕುಶಲತೆಯನ್ನು ಕಟ್ಟುನಿಟ್ಟಾದ ಪರಿಸರ ಮಾನದಂಡಗಳೊಂದಿಗೆ ಸಂಯೋಜಿಸಿ, ಸಾಟಿಯಿಲ್ಲದ ಶುಚಿಗೊಳಿಸುವ ಶಕ್ತಿಯೊಂದಿಗೆ ಕೈಗೆಟುಕುವ, ಉತ್ತಮ ಗುಣಮಟ್ಟದ ಉತ್ಪನ್ನಗಳನ್ನು ನೀಡುತ್ತೇವೆ.",
            34: "ನಮ್ಮ ಮೂಲ ಮೌಲ್ಯಗಳು",
            35: "ನಂಬಿಕೆ",
            36: "ಶ್ರೇಷ್ಠತೆ",
            37: "ವಿಶ್ವಾಸಾರ್ಹತೆ",
            38: "ಪೂಜ್ಯ ಭಾವನೆ",
            39: "ಮಹತ್ವಾಕಾಂಕ್ಷೆ",
            40: "ದೃಷ್ಟಿ",
            41: "ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ, ಗೌರವಿಸಲ್ಪಟ್ಟ ಮತ್ತು ವಿಶ್ವಸನೀಯ ವಾಣಿಜ್ಯ ಶುದ್ಧೀಕರಣ ಉತ್ಪನ್ನ ಬ್ರಾಂಡ್ ಆಗಲು. ನಾವು ಮಾಡುವುದರಲ್ಲಿ ಶ್ರೇಷ್ಠರಾಗಿರಲು...",
            42: "ಗುರಿ",
            43: "ದೃಢವಾದ ಶುದ್ಧೀಕರಣ ಉತ್ಪನ್ನಗಳ ಶ್ರೇಣಿ, ಉದ್ಯಮ-ಮುಂಚೂಣಿಯ ಮಾನದಂಡಗಳು ಮತ್ತು ಸ್ಥಿರವಾದ ವ್ಯವಹಾರ ಅಭ್ಯಾಸಗಳ ಮೂಲಕ ಉತ್ಪಾದಕ, ಸುರಕ್ಷಿತ ಮತ್ತು ಆರೋಗ್ಯಕರ ಪರಿಸರ.",
            44: "ನಿಮ್ಮ ಆರೋಗ್ಯದ ಬಗ್ಗೆ ನಾವು ವಿಶೇಷ ಕಾಳಜಿ ವಹಿಸುತ್ತೇವೆ",
            45: "ನೀವು ಹುಡುಕುತ್ತಿದ್ದ ಆಲ್ ಇನ್ ಒನ್ ಕ್ಲೀನಿಂಗ್ ಉತ್ಪನ್ನಗಳು",
            46: "ಟೆರಾಕ್ಲೆನ್ಜ್ ಉತ್ಪನ್ನದ ಪ್ರಯೋಜನಗಳು",
            47: "ಸೂಕ್ಷ್ಮಜೀವ ವಿರೋಧಿ ಗುಣಲಕ್ಷಣಗಳು",
            48: "ವಿಷರಹಿತ ಮತ್ತು ಅಪಾಯಕಾರಿಯಲ್ಲ",
            49: "ನ್ಯಾನೋ ತಂತ್ರಜ್ಞಾನ ಅನುಷ್ಠಾನಗೊಂಡಿದೆ",
            50: "ಜೈವಿಕವಾಗಿ ಕ್ಷಯಿಸುವ",
            51: "ಉತ್ಪನ್ನದ ಬೆಲೆ ಮತ್ತು ಗುಣಮಟ್ಟ",
            52: "ಪರಿಸರ ಸ್ನೇಹಿ",
            53: "ನಮ್ಮ ಉತ್ಪನ್ನ ಕೊಡುಗೆಗಳು",
            54: "ಕೈ ತೊಳೆಯುವ ಮಿಶ್ರ ಹಣ್ಣು | ನ್ಯಾನೋ ಸ್ಲಿವರ್",
            55: "ಸ್ನಾನದ ಕೋಣೆ ಶುದ್ಧಕಾರಕ | ಶುದ್ಧಕಾರಕ",
            56: "ಗಾಜು ಮತ್ತು ಕನ್ನಡಿ ಕ್ಲೀನರ್ | ನ್ಯಾನೊಕಾಪರ್",
            57: "ನೆಲ ಸ್ವಚ್ಛಗೊಳಿಸುವ ಮತ್ತು ಸೋಂಕುನಿವಾರಕ | ನ್ಯಾನೊಕಾಪರ್",
            58: "ಸ್ನಾನದ ಕೋಣೆಯ ಗೋಡೆ ಮತ್ತು ಟೈಲ್ ಕ್ಲೀನರ್ | ಗೃಹಬಳಕೆ ಮತ್ತು ಕೈಗಾರಿಕಾ ಬಳಕೆ",
            59: "ಸ್ನಾನದ ಮನೆ ಮತ್ತು ಮೂತ್ರವಿಸರ್ಜನೆ ಸ್ಥಳ ಶುದ್ಧಕಾರಕ | ಗೃಹಬಳಕೆ ಮತ್ತು ಕೈಗಾರಿಕಾ ಬಳಕೆ",
            60: "ಯಂತ್ರಕ ಕ್ಲೀನರ್ | ನ್ಯಾನೊಕಾಪರ್",
            61: "ಸೋಡಿಯಂ ಹೈಪೋಕ್ಲೋರೈಟ್ ದ್ರಾವಣಗಳು | ನ್ಯಾನೊಕಾಪರ್",
            62:"ನಾವು ಕಠಿಣ ಗುಣಮಟ್ಟದ ಮಾನದಂಡಗಳನ್ನು ಅನುಸರಿಸುತ್ತೇವೆ ಮತ್ತು ಮಾರುಕಟ್ಟೆಯಲ್ಲಿ ಅತ್ಯುತ್ತಮ ಒಪ್ಪಂದವನ್ನು ಖಚಿತಪಡಿಸುತ್ತೇವೆ.",
            63:"assets/img/portfolio/kannada.png",
            64:"assets/img/portfolio/kannadamobile.png"
          };
        
          const homete = {
            1: "అత్యాధునిక నానోటెక్నాలజీతో శుభ్రతలో విప్లవాత్మక మార్పు!",
            2: "మేము నానో కాపర్ & నానో సిల్వర్ టెక్నాలజీ ఉత్పత్తుల్లో నిపుణులం.",
            3: "మరింత తెలుసుకోండి",
            4: "నానో గురించి",
            5: "నానో అంటే ఏమిటి ?",
            6: "నానోటెక్నాలజీ అనేది పరమాణు స్థాయిలో పదార్థాలను నియంత్రించే లేదా మౌలిక మార్పులు చేయగల సామర్థ్యం, దీనివల్ల వాటి పరిమాణం, ఆకారం లేదా కూర్పు కారణంగా ప్రత్యేక లక్షణాలు మరియు ఫంక్షన్లు ఏర్పడతాయి. ఈ నిర్మాణాలు సాధారణంగా నానోమీటర్ల పరిమాణంలో ఉంటాయి. ఒక మిల్లీమీటర్ నుండి నానోమీటర్ స్థాయికి మారే ప్రక్రియలో, నిర్దిష్ట ఉపరితల ప్రాంతం మూడు రెట్లు పెరుగుతుంది, దీని వల్ల దాని భౌతిక, రసాయన, యాంత్రిక, విద్యుత్, అయస్కాంత, జీవశాస్త్ర లక్షణాలు మారుతాయి.",
            7: "అభినవ నానోటెక్ పరిష్కారాలు",
            8: "అనుపమానమైన నాణ్యత",
            9: "పర్యావరణహిత నైపుణ్యం",
            10: "యాంటీ మైక్రోబయల్ లక్షణాలు",
            11: "విషరహిత & హానికరం కానిది",
            12: "అపూర్వమైన శుభ్రపరిచే శక్తితో సరసమైన, అధిక నాణ్యత గల ఉత్పత్తులను అందిస్తోంది",
            13: "మమ్మల్ని ఎందుకు ఎంచుకోవాలి",
            14: "మా ఉత్పత్తి మీ ఇంటి లేదా కార్యాలయంలోని అన్ని ప్రాంతాలను కవర్ చేస్తుంది",
            15: "ప్రతి మూలను రక్షించేందుకు రూపొందించబడింది - మా ఉత్పత్తి మీ ఇల్లు మరియు కార్యాలయాన్ని సురక్షితంగా, భద్రంగా, ఒత్తిడిలేని స్థలంగా మార్చుతుంది",
            16: 'డీప్ క్లీనింగ్ ("యాంటీ మైక్రోబయల్, యాంటీ-ఫంగల్, యాంటీ-వైరల్, యాంటీ-బాక్టీరియల్")',
            17: 'బహుముఖత ("ఎక్కువ ఉపరితలాలకు అనువైనది")',
            18: 'విషరహితత ("మనుషులకు, పెంపుడు జంతువులకు మరియు పర్యావరణానికి హానికరం కాదు")',
            19: 'అధిక పనితీరు ("అత్యాధునిక సాంకేతికత అధిక పనితీరుకు")',
            20: 'పర్యావరణహిత ("బయోడిగ్రేడబుల్ మరియు తక్కువ నీటి వినియోగాన్ని కలిగి ఉంది")',
            21: 'ఖర్చు తగ్గింపు ("ఈ ఉత్పత్తులు మొత్తం నిర్వహణ వ్యయాన్ని తగ్గించగలవు.")',
            22: "మా ఉత్పత్తులు ప్రముఖంగా ఉపయోగించే ప్రాంతాలు",
            23: "వంటగది శుభ్రపరచడం",
            24: "ఆసుపత్రి శుభ్రపరచడం",
            25: "సాధారణ ఉత్పత్తులు",
            26: "మా గురించి",
            27: "మా అత్యుత్తమ సేవలు & ప్రముఖ ఉత్పత్తులు ఇక్కడ",
            28: "టెర్రా క్లెంజ్ అనేది విస్తృత ఉపయోగాల కోసం నానోటెక్నాలజీతో అసాధారణమైన శుభ్రపరిచే ఉత్పత్తులను తయారు చేసే కంపెనీ. మేము నానో కాపర్ & నానో సిల్వర్ టెక్నాలజీ ఉత్పత్తుల్లో ప్రత్యేకత కలిగి ఉన్నాము.",
            29: "ప్రతిరోజూ ఉపయోగించగల నానోటెక్ పరిష్కారాలు",
            30: "నవీనమైన, నానోటెక్నాలజీ ఆధారిత ఉత్పత్తుల గొలుసు & చిల్లర విక్రయాలలో మేము ప్రత్యేకత కలిగి ఉన్నాము.",
            31: "అనుపమాన నాణ్యత, అపరిమిత విలువ – హామీతో!",
            32: "పర్యావరణహిత నైపుణ్యం మరియు అసాధారణ శుభ్రపరిచే శక్తి",
            33: "మేము ఖచ్చితమైన నైపుణ్యాన్ని కఠినమైన పర్యావరణ ప్రమాణాలతో కలిపి, అపూర్వమైన శుభ్రపరిచే శక్తిని అందించే అధిక నాణ్యత గల ఉత్పత్తులను అందిస్తున్నాము.",
            34: "మా ప్రాముఖ్యమైన విలువలు",
            35: "నమ్మకం",
            36: "శ్రేష్ఠత",
            37: "నమ్మదగినత",
            38: "గౌరవం",
            39: "ఆసక్తి",
            40: "దృష్టి",
            41: "అత్యంత విశ్వసనీయమైన, గౌరవనీయమైన మరియు నమ్మదగిన వాణిజ్య శుభ్రపరిచే ఉత్పత్తుల బ్రాండ్‌గా మారడం. మేము చేసే పనిలో ఉత్తమంగా ఉండాలి...",
            42: "మిషన్",
            43: "సురక్షితమైన, ఆరోగ్యకరమైన మరియు ఉత్పాదకమైన పర్యావరణాన్ని అత్యుత్తమ శుభ్రపరిచే ఉత్పత్తులతో, పరిశ్రమలో ముందంజలో ఉన్న ప్రమాణాలతో మరియు స్థిరమైన వ్యాపార విధానాలతో అందించడం.",
            44: "మీ ఆరోగ్యాన్ని మేము జాగ్రత్తగా చూసుకుంటాము",
            45: "మీరు కోరుకున్న ఒకే ఒక శుభ్రపరిచే ఉత్పత్తి",
            46: "టెర్రాక్లెంజ్ ఉత్పత్తుల ప్రయోజనాలు",
            47: "యాంటీ మైక్రోబయల్ లక్షణాలు",
            48: "విషరహిత & హానికరం కానిది",
            49: "నానోటెక్నాలజీ ఉపయోగించబడింది",
            50: "జీవ వైతాళ్యం కలిగి ఉంది",
            51: "ఉత్పత్తి ధర & నాణ్యత",
            52: "పర్యావరణహితం",
            53: "మా ఉత్పత్తి శ్రేణి",
            54: "హ్యాండ్ వాష్ మిక్స్‌డ్ ఫ్రూట్ | నానో సిల్వర్",
            55: "బాత్‌రూమ్ క్లీనర్ | క్లీనర్",
            56: "గ్లాస్ & మిర్రర్ క్లీనర్ | నానో కాపర్",
            57: "ఫ్లోర్ క్లీనర్ & క్లీన్ డిజైన్ఫెక్టెంట్ | నానో కాపర్",
            58: "బాత్‌రూమ్ వాల్ & టైల్ క్లీనర్ | గృహ & పారిశ్రామిక ఉపయోగం",
            59: "టాయిలెట్ బౌల్ & యురినల్ క్లీనర్ | గృహ & పారిశ్రామిక ఉపయోగం",
            60: "గాడ్జెట్ క్లీనర్ | నానో కాపర్",
            61: "సోడియం హైపోక్లోరైట్ సొల్యూషన్ | నానో కాపర్",
            62:"మేము కఠినమైన నాణ్యతా ప్రమాణాలను అనుసరిస్తాము మరియు మార్కెట్లో ఉత్తమమైన ఆఫర్‌ను హామీ ఇస్తాము.",
            63:"assets/img/portfolio/telugu.png",
            64:"assets/img/portfolio/telugumobile.png"
          };
          const homehi = {
            1: "अत्याधुनिक नैनो टेक्नोलॉजी के साथ सफाई में क्रांति!",
            2: "हम नैनो कॉपर और नैनो सिल्वर तकनीक उत्पादों में विशेषज्ञ हैं।",
            3: "और अधिक जानें",
            4: "नैनो के बारे में",
            5: "नैनो क्या है ?",
            6: "नैनो टेक्नोलॉजी वह क्षमता है जिसके द्वारा परमाणु स्तर पर सामग्रियों को नियंत्रित या हेरफेर किया जा सकता है ताकि उनकी संरचना के कारण उनके आकार, रूप या संरचना के नए गुण और कार्य हों। ये संरचनाएं आमतौर पर नैनोमीटर आकार की होती हैं। जब हम मिलीमीटर से नैनोमीटर पैमाने पर जाते हैं, तो विशिष्ट सतह क्षेत्र तीन गुना बढ़ जाता है, जिससे इसके भौतिक, रासायनिक, यांत्रिक, विद्युत, चुंबकीय और जैविक गुण बदल जाते हैं।",
            7: "नवाचारपूर्ण नैनो तकनीक समाधान",
            8: "अद्वितीय गुणवत्ता",
            9: "पर्यावरण-अनुकूल कारीगरी",
            10: "एंटी-माइक्रोबियल गुण",
            11: "गैर विषाक्त और गैर-हानिकारक",
            12: "अत्यधिक सफाई शक्ति के लिए किफायती, उच्च-गुणवत्ता वाले उत्पाद प्रदान करना",
            13: "हमें क्यों चुनें",
            14: "हमारा उत्पाद आपके घर या कार्यालय के सभी क्षेत्रों को कवर करेगा",
            15: "हर कोने की सुरक्षा के लिए डिज़ाइन किया गया - हमारा उत्पाद सुनिश्चित करता है कि आपका घर और कार्यालय सुरक्षित, संरक्षित और तनावमुक्त रहे।",
            16: 'डीप क्लीनिंग ("एंटी-माइक्रोबियल, एंटी-फंगल, एंटी-वायरल, एंटी-बैक्टीरियल")',
            17: 'बहुप्रयोजी ("कई सतहों के लिए उपयुक्त")',
            18: 'गैर-विषाक्त ("मानव, पालतू जानवर और पर्यावरण के लिए सुरक्षित")',
            19: 'उच्च प्रदर्शन ("उन्नत तकनीक द्वारा उच्च प्रदर्शन")',
            20: 'पर्यावरण-अनुकूल ("बायोडिग्रेडेबल और जल उपयोग को कम करता है")',
            21: 'लागत-कुशलता ("ये उत्पाद समग्र रखरखाव लागत को कम कर सकते हैं।")',
            22: "हमारे उत्पादों की लोकप्रियता",
            23: "रसोई की सफाई",
            24: "अस्पताल की सफाई",
            25: "सामान्य उत्पाद",
            26: "हमारे बारे में",
            27: "हमारी सर्वश्रेष्ठ सेवाएं और लोकप्रिय उत्पाद यहाँ",
            28: "टे़रा क्लेंज एक कंपनी है, जो नैनो टेक्नोलॉजी के साथ विभिन्न अनुप्रयोगों के लिए उत्कृष्ट सफाई उत्पाद बनाती है। हम नैनो कॉपर और नैनो सिल्वर तकनीक उत्पादों में विशेषज्ञ हैं।",
            29: "दैनिक जीवन के लिए नवाचारपूर्ण नैनो तकनीक समाधान",
            30: "हम नवीन, नैनो टेक्नोलॉजी-संवर्धित उत्पादों की थोक और खुदरा बिक्री में विशेषज्ञता रखते हैं जो दैनिक जीवन में उपयोग किए जा सकते हैं।",
            31: "बेजोड़ गुणवत्ता, बेहतरीन मूल्य - गारंटीड!",
            32: "पर्यावरण-अनुकूल कारीगरी और उच्च सफाई शक्ति",
            33: "हम कठोर पर्यावरणीय मानकों का पालन करते हुए सटीक कारीगरी के साथ किफायती, उच्च-गुणवत्ता वाले उत्पाद प्रदान करते हैं।",
            34: "हमारे मूल मूल्य",
            35: "विश्वास",
            36: "उत्कृष्टता",
            37: "विश्वसनीयता",
            38: "आदर",
            39: "महत्वाकांक्षा",
            40: "दृष्टिकोण",
            41: "सबसे विश्वसनीय, सम्मानित और भरोसेमंद वाणिज्यिक सफाई उत्पाद ब्रांड बनने का लक्ष्य। जो हम करते हैं उसमें सर्वश्रेष्ठ बनने की आकांक्षा।",
            42: "मिशन",
            43: "सफाई उत्पादों की एक मजबूत श्रृंखला, उद्योग-अग्रणी मानकों और स्थायी व्यावसायिक प्रथाओं के माध्यम से एक उत्पादक, सुरक्षित और स्वस्थ पर्यावरण प्रदान करना।",
            44: "हम आपके स्वास्थ्य का ख्याल रखते हैं",
            45: "वह ऑल-इन-वन सफाई उत्पाद जिसे आप खोज रहे थे",
            46: "टे़रा क्लेंज उत्पादों के लाभ",
            47: "एंटी-माइक्रोबियल गुण",
            48: "गैर-विषाक्त और गैर-हानिकारक",
            49: "नैनो टेक्नोलॉजी युक्त",
            50: "बायोडिग्रेडेबल",
            51: "उत्पाद मूल्य और गुणवत्ता",
            52: "पर्यावरण-अनुकूल",
            53: "हमारे उत्पाद ऑफरिंग्स",
            54: "हैंड वॉश मिक्स्ड फ्रूट | नैनो सिल्वर",
            55: "बाथरूम क्लीनर | क्लीनर",
            56: "ग्लास और मिरर क्लीनर | नैनो कॉपर",
            57: "फ्लोर क्लीनर और डिसइंफेक्टेंट | नैनो कॉपर",
            58: "बाथरूम वॉल और टाइल क्लीनर | घरेलू और औद्योगिक उपयोग",
            59: "टॉयलेट बाउल और यूरिनल क्लीनर | घरेलू और औद्योगिक उपयोग",
            60: "गैजेट क्लीनर | नैनो कॉपर",
            61: "सोडियम हाइपो क्लोराइट सॉल्यूशन | नैनो कॉपर",
            62:"हम सबसे कड़े गुणवत्ता मानकों का पालन करते हैं और बाजार में सर्वोत्तम प्रस्ताव की गारंटी देते हैं।",
            63:"assets/img/portfolio/hindi.png",
            64:"assets/img/portfolio/hindimobile.png"
          };
          const [homeen, setHomeen] = useState(homee);
          const [bgImage, setBgImage] = useState(homeen["63"]); // Default to desktop image
          useEffect(() => {
            const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
            switch (storedLanguage) {
              case "kn":
                setHomeen(homeka);
                break;
              case "te":
                setHomeen(homete);
                break;
              case "ta":
                setHomeen(hometa);
                break;
              case "hi":
                setHomeen(homehi);
                break;
              default:
                setHomeen(homee);
            }
          }, []);

          useEffect(() => {
            // Function to update the background based on screen width
            const updateBgImage = () => {
                if (window.innerWidth <= 768) { // Adjust breakpoint if needed
                    setBgImage(homeen["64"]); // Mobile image
                } else {
                    setBgImage(homeen["63"]); // Desktop image
                }
            };
    
            // Set initial background and listen for window resize
            updateBgImage();
            window.addEventListener("resize", updateBgImage);
    
            // Cleanup event listener
            return () => window.removeEventListener("resize", updateBgImage);
        }, [homeen]);

  return (
    <>
    {/* <div className='aboutus_container'>
        
        <div className='aboutus_content'>
        <div className="custom-shape-divider-top-1741929560">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
    </svg>
</div>
        <ul className='aboutus_content_list'>
        <h1 className='about_us_heading_new'>{homeen["26"]}</h1>
        <p style={{color:"rgb(9, 22, 125)",fontSize:"20px"}}>
        {homeen["28"]}
        </p>
        <li style={{marginBottom:"10px"}}>
            <h6 style={{color:"white"}}>{homeen["29"]}
            </h6>
            <span >{homeen["30"]}</span>
        </li>
        <li style={{marginBottom:"10px"}}>
            <h6 style={{color:"white"}}>{homeen["31"]}
            </h6>
            <span>{homeen["62"]}
            </span>
        </li>
        <li style={{marginBottom:"10px"}}>
            <h6 style={{color:"white"}}>{homeen["32"]}
            </h6>
            <span>{homeen["33"]}</span>
        </li>
        <li>
            <button className='about_terra_button'><a href="/products">Fix The Product Here </a><FaArrowRight/></button>
        </li>
        </ul>
        
        </div>
        <div>
            <img src="./assets/img/products/about_terra2.png" alt="aboutus_image_terra" className='aboutus_image_terra'/>
        </div>
    </div>

    <section class="contact-us-wrap mt-5">
          <div class="container">
            <div className="section-title style1 text-center mb-40 ">
              <div class="row justify-content-center pb-20">
                <div class="col-xl-6 col-lg-6 col-md-6">
                  <div className="product_benefits_container pt-20">
                    <div className="product_background_image"></div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6">
                  <div class="contact-info" style={{ textAlign: "left" }}>
                    <h3>{homeen["40"]}</h3>
                    <p style={{ color: "black", fontWeight: "600" }}>
                      {homeen["41"]}
                    </p>
                  </div>

                  <div
                    class="contact-info"
                    style={{ textAlign: "left", marginTop: "3vh" }}
                  >
                    <h3>{homeen["42"]}</h3>
                    <p style={{ color: "black", fontWeight: "600" }}>
                      {homeen["43"]}
                    </p>
                  </div>
                  <div>
                    <div class="row gx-0 align-items-center">
                      <div class="col-md-7 col-12"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

<div class="container h-100 py-5" style={{marginTop:"60px"}}>
 
<h3 className="about_us_heading_new">{homeen["26"]}</h3>
<div 
    className="new_image_bg" 
    style={{ 
      backgroundImage: `url(${bgImage})`, 
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
  }}
>


 {/* <div className='content_new_karthik'>
            <div className='sub_content_karthik'>
             <h6>{homeen["29"]}</h6>
             <p style={{fontSize:"14px"}}>{homeen["30"]}</p>
            </div>  
           
           <div style={{display:"flex",flexDirection:"column"}}>
            <div className='sub_content_karthik'>
             <h6>{homeen["31"]}</h6>
             <p style={{fontSize:"14px"}}>{homeen["62"]}</p>
            </div>  

            <div className='sub_content_karthik'>
             <h6>{homeen["32"]}</h6>
             <p style={{fontSize:"14px"}}>{homeen["33"]}
             </p>
            </div>  
            </div>
             
 </div> */}


     </div>
     
     <section class="contact-us-wrap">
       <div class="container">
         <div className="section-title style1 text-center mb-40 mt-30">
           <div class="row justify-content-center pb-20">
             
             <div class="col-xl-6 col-lg-6 col-md-6">
               <div class="contact-info card_karthik_new_mission" style={{ textAlign: "left" }}>
                 <h3>{homeen["40"]}</h3>
                 <p style={{ color: "black", fontWeight: "600" }}>
                 {homeen["41"]}
                 </p>
               </div> 
             </div>
             <div class="col-xl-6 col-lg-6 col-md-6">
             
               <div
                 class="contact-info card_karthik_new_mission"
                 style={{ textAlign: "left"}}
               >
                 <h3>{homeen["42"]}</h3>
                 <p style={{ color: "black", fontWeight: "600" }}>
                 {homeen["43"]}
                 </p>
               </div>
               
             </div>
           </div>
         </div>
       </div>
     </section>

</div>
    </>
  )
}

export default AboutUsTerra
